import { ValidationRuleDTO } from "./validationRuleDTO";

export class ValidationProtocolOverrideDTO{

    public sequenceNo!: number;
    public validationRules!: ValidationRuleDTO[];
    public validationOr!: boolean;

    constructor(){
        this.validationRules = new Array();
    }

    
}